import React, { ReactNode } from "react";

import Icons from "@/utils/Icons";

interface EmptyStateProps {
  icon?: string | ReactNode;
  title: string;
  message?: string;
  iconSize?: number;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon = "cloud-upload-2",
  title,
  message,
  iconSize = 48,
}) => {
  return (
    <div className='col-span-full flex justify-center items-center py-12'>
      <div className='text-center flex flex-col items-center justify-center'>
        {typeof icon === "string" ? (
          <Icons name={icon} size={iconSize} />
        ) : (
          icon
        )}
        <h3 className='text-lg font-medium text-gray-700'>{title}</h3>
        {message && <p className='text-sm text-gray-500 mt-1'>{message}</p>}
      </div>
    </div>
  );
};

export default EmptyState;
